import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5a727380 = () => interopDefault(import('../pages/request-for-tender/index.vue' /* webpackChunkName: "pages/request-for-tender/index" */))
const _5751fb74 = () => interopDefault(import('../pages/customer-registration/index.vue' /* webpackChunkName: "pages/customer-registration/index" */))
const _14741178 = () => interopDefault(import('../pages/price-offer/index.vue' /* webpackChunkName: "pages/price-offer/index" */))
const _b26bb110 = () => interopDefault(import('../pages/price-offer-registration/index.vue' /* webpackChunkName: "pages/price-offer-registration/index" */))
const _71fcfa18 = () => interopDefault(import('../pages/prices/index.vue' /* webpackChunkName: "pages/prices/index" */))
const _0a6a041a = () => interopDefault(import('../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _0b07dfb5 = () => interopDefault(import('../pages/auto-login/index.vue' /* webpackChunkName: "pages/auto-login/index" */))
const _908b9d56 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _48caa40c = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _a380e538 = () => interopDefault(import('../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _6495c202 = () => interopDefault(import('../pages/elso-belepes/index.vue' /* webpackChunkName: "pages/elso-belepes/index" */))
const _2d173a0a = () => interopDefault(import('../pages/email-confirm/index.vue' /* webpackChunkName: "pages/email-confirm/index" */))
const _2a3e2504 = () => interopDefault(import('../pages/health-check.vue' /* webpackChunkName: "pages/health-check" */))
const _fb72cc32 = () => interopDefault(import('../pages/heroku-login.vue' /* webpackChunkName: "pages/heroku-login" */))
const _47206ed6 = () => interopDefault(import('../pages/inspiration/index.vue' /* webpackChunkName: "pages/inspiration/index" */))
const _d816bdb0 = () => interopDefault(import('../pages/career/index.vue' /* webpackChunkName: "pages/career/index" */))
const _0b624f82 = () => interopDefault(import('../pages/koszonjuk/index.vue' /* webpackChunkName: "pages/koszonjuk/index" */))
const _733c9bff = () => interopDefault(import('../pages/leiratkozas/index.vue' /* webpackChunkName: "pages/leiratkozas/index" */))
const _dd5630b6 = () => interopDefault(import('../pages/job-notification/index.vue' /* webpackChunkName: "pages/job-notification/index" */))
const _61aa34d3 = () => interopDefault(import('../pages/no-password/index.vue' /* webpackChunkName: "pages/no-password/index" */))
const _3b403203 = () => interopDefault(import('../pages/oauth-register/index.vue' /* webpackChunkName: "pages/oauth-register/index" */))
const _b95be240 = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _524fed63 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _a1700f48 = () => interopDefault(import('../pages/registration/introduction/index.vue' /* webpackChunkName: "pages/registration/introduction/index" */))
const _500d6820 = () => interopDefault(import('../pages/registration/email/index.vue' /* webpackChunkName: "pages/registration/email/index" */))
const _ad4c4dc6 = () => interopDefault(import('../pages/registration/password/index.vue' /* webpackChunkName: "pages/registration/password/index" */))
const _b5fd23a2 = () => interopDefault(import('../pages/registration/jobfeed/index.vue' /* webpackChunkName: "pages/registration/jobfeed/index" */))
const _35ab188d = () => interopDefault(import('../pages/registration/name/index.vue' /* webpackChunkName: "pages/registration/name/index" */))
const _56af3edc = () => interopDefault(import('../pages/registration/picture/index.vue' /* webpackChunkName: "pages/registration/picture/index" */))
const _c475fd52 = () => interopDefault(import('../pages/registration/success/index.vue' /* webpackChunkName: "pages/registration/success/index" */))
const _735f8a6a = () => interopDefault(import('../pages/registration/professions/index.vue' /* webpackChunkName: "pages/registration/professions/index" */))
const _af78cffe = () => interopDefault(import('../pages/registration/invoice/index.vue' /* webpackChunkName: "pages/registration/invoice/index" */))
const _6a739f42 = () => interopDefault(import('../pages/registration/phone/index.vue' /* webpackChunkName: "pages/registration/phone/index" */))
const _6615c126 = () => interopDefault(import('../pages/registration/city/index.vue' /* webpackChunkName: "pages/registration/city/index" */))
const _175a9af0 = () => interopDefault(import('../pages/registration/_.vue' /* webpackChunkName: "pages/registration/_" */))
const _31ae2552 = () => interopDefault(import('../pages/salaries/index.vue' /* webpackChunkName: "pages/salaries/index" */))
const _0db28748 = () => interopDefault(import('../pages/salary-checker/index.vue' /* webpackChunkName: "pages/salary-checker/index" */))
const _565205b9 = () => interopDefault(import('../pages/questions/index.vue' /* webpackChunkName: "pages/questions/index" */))
const _317cd4b4 = () => interopDefault(import('../pages/profession/index.vue' /* webpackChunkName: "pages/profession/index" */))
const _3dcf3a3e = () => interopDefault(import('../pages/szerzodesmintak/index.vue' /* webpackChunkName: "pages/szerzodesmintak/index" */))
const _757c5333 = () => interopDefault(import('../pages/cities/index.vue' /* webpackChunkName: "pages/cities/index" */))
const _2c31a3dc = () => interopDefault(import('../pages/new-password/index.vue' /* webpackChunkName: "pages/new-password/index" */))
const _06fc26ab = () => interopDefault(import('../pages/new-professionals/index.vue' /* webpackChunkName: "pages/new-professionals/index" */))
const _6e9a3916 = () => interopDefault(import('../pages/velemeny/index.vue' /* webpackChunkName: "pages/velemeny/index" */))
const _4406f213 = () => interopDefault(import('../pages/conductor/index.vue' /* webpackChunkName: "pages/conductor/index" */))
const _b6d5b74a = () => interopDefault(import('../pages/visszajelzes/index.vue' /* webpackChunkName: "pages/visszajelzes/index" */))
const _7aa3a8ef = () => interopDefault(import('../pages/components/buttons.vue' /* webpackChunkName: "pages/components/buttons" */))
const _20d5d42a = () => interopDefault(import('../pages/components/inputs.vue' /* webpackChunkName: "pages/components/inputs" */))
const _4b5bd1ee = () => interopDefault(import('../pages/components/misc.vue' /* webpackChunkName: "pages/components/misc" */))
const _219ca633 = () => interopDefault(import('../pages/demo/price-offers/index.vue' /* webpackChunkName: "pages/demo/price-offers/index" */))
const _b46cabbe = () => interopDefault(import('../pages/documents/cookies.vue' /* webpackChunkName: "pages/documents/cookies" */))
const _62aad9cd = () => interopDefault(import('../pages/my-account/my-tenders/index.vue' /* webpackChunkName: "pages/my-account/my-tenders/index" */))
const _3c131fce = () => interopDefault(import('../pages/my-account/prices/index.vue' /* webpackChunkName: "pages/my-account/prices/index" */))
const _a58033ac = () => interopDefault(import('../pages/my-account/price-offers/index.vue' /* webpackChunkName: "pages/my-account/price-offers/index" */))
const _0c8d3e11 = () => interopDefault(import('../pages/my-account/tile-designer/index.vue' /* webpackChunkName: "pages/my-account/tile-designer/index" */))
const _6e41ee2c = () => interopDefault(import('../pages/my-account/subscription/index.vue' /* webpackChunkName: "pages/my-account/subscription/index" */))
const _64fb9938 = () => interopDefault(import('../pages/my-account/my-ratings/index.vue' /* webpackChunkName: "pages/my-account/my-ratings/index" */))
const _8d87a6a6 = () => interopDefault(import('../pages/my-account/jobs-in-progress/index.vue' /* webpackChunkName: "pages/my-account/jobs-in-progress/index" */))
const _81d52a8e = () => interopDefault(import('../pages/my-account/favourites/index.vue' /* webpackChunkName: "pages/my-account/favourites/index" */))
const _07965c84 = () => interopDefault(import('../pages/my-account/closed-jobs/index.vue' /* webpackChunkName: "pages/my-account/closed-jobs/index" */))
const _5b61cb88 = () => interopDefault(import('../pages/my-account/won-jobs/index.vue' /* webpackChunkName: "pages/my-account/won-jobs/index" */))
const _d066ed6a = () => interopDefault(import('../pages/my-account/obtainable-jobs/index.vue' /* webpackChunkName: "pages/my-account/obtainable-jobs/index" */))
const _81489a52 = () => interopDefault(import('../pages/my-account/references/index.vue' /* webpackChunkName: "pages/my-account/references/index" */))
const _6de9bfe2 = () => interopDefault(import('../pages/my-account/product-catalog/index.vue' /* webpackChunkName: "pages/my-account/product-catalog/index" */))
const _4f53eb62 = () => interopDefault(import('../pages/my-account/designers/index.vue' /* webpackChunkName: "pages/my-account/designers/index" */))
const _77b7d248 = () => interopDefault(import('../pages/fizetes/folyamatban.vue' /* webpackChunkName: "pages/fizetes/folyamatban" */))
const _c4e37d84 = () => interopDefault(import('../pages/fizetes/sikeres.vue' /* webpackChunkName: "pages/fizetes/sikeres" */))
const _bd5b12b8 = () => interopDefault(import('../pages/fizetes/sikertelen.vue' /* webpackChunkName: "pages/fizetes/sikertelen" */))
const _61e9e5b8 = () => interopDefault(import('../pages/salary-checker/fizuk.js' /* webpackChunkName: "pages/salary-checker/fizuk" */))
const _53e0e15f = () => interopDefault(import('../pages/static/faq/index.vue' /* webpackChunkName: "pages/static/faq/index" */))
const _ede13eea = () => interopDefault(import('../pages/static/about-us/index.vue' /* webpackChunkName: "pages/static/about-us/index" */))

const _4a2811df = () => interopDefault(import('../pages/questions/new-question/index.vue' /* webpackChunkName: "pages/questions/new-question/index" */))
const _d6bb450e = () => interopDefault(import('../pages/velemeny/koszonjuk.vue' /* webpackChunkName: "pages/velemeny/koszonjuk" */))
const _512be9ba = () => interopDefault(import('../pages/conductor/tenders/index.vue' /* webpackChunkName: "pages/conductor/tenders/index" */))
const _450e7ea8 = () => interopDefault(import('../pages/conductor/request-tender-page-modules/index.vue' /* webpackChunkName: "pages/conductor/request-tender-page-modules/index" */))
const _94a05c16 = () => interopDefault(import('../pages/conductor/settings/index.vue' /* webpackChunkName: "pages/conductor/settings/index" */))
const _bf17f398 = () => interopDefault(import('../pages/conductor/blog/index.vue' /* webpackChunkName: "pages/conductor/blog/index" */))
const _531002bc = () => interopDefault(import('../pages/conductor/crm/index.vue' /* webpackChunkName: "pages/conductor/crm/index" */))
const _2f32290c = () => interopDefault(import('../pages/conductor/email-templates/index.vue' /* webpackChunkName: "pages/conductor/email-templates/index" */))
const _424164ba = () => interopDefault(import('../pages/conductor/ratings/index.vue' /* webpackChunkName: "pages/conductor/ratings/index" */))
const _bd15a428 = () => interopDefault(import('../pages/conductor/notifications/index.vue' /* webpackChunkName: "pages/conductor/notifications/index" */))
const _6a86b802 = () => interopDefault(import('../pages/conductor/persons/index.vue' /* webpackChunkName: "pages/conductor/persons/index" */))
const _0f9857ff = () => interopDefault(import('../pages/conductor/front-page-modules/index.vue' /* webpackChunkName: "pages/conductor/front-page-modules/index" */))
const _1b34de22 = () => interopDefault(import('../pages/conductor/faqs/index.vue' /* webpackChunkName: "pages/conductor/faqs/index" */))
const _5388a418 = () => interopDefault(import('../pages/conductor/newsletter-subscriptions/index.vue' /* webpackChunkName: "pages/conductor/newsletter-subscriptions/index" */))
const _48105c52 = () => interopDefault(import('../pages/conductor/person-event-log-types/index.vue' /* webpackChunkName: "pages/conductor/person-event-log-types/index" */))
const _b61144ca = () => interopDefault(import('../pages/conductor/inspirations/index.vue' /* webpackChunkName: "pages/conductor/inspirations/index" */))
const _01bd84ec = () => interopDefault(import('../pages/conductor/subcounties/index.vue' /* webpackChunkName: "pages/conductor/subcounties/index" */))
const _47600c68 = () => interopDefault(import('../pages/conductor/legal-documents/index.vue' /* webpackChunkName: "pages/conductor/legal-documents/index" */))
const _0785ba66 = () => interopDefault(import('../pages/conductor/person-favourites/index.vue' /* webpackChunkName: "pages/conductor/person-favourites/index" */))
const _411086de = () => interopDefault(import('../pages/conductor/questions/index.vue' /* webpackChunkName: "pages/conductor/questions/index" */))
const _2d45d778 = () => interopDefault(import('../pages/conductor/flagged-contacts/index.vue' /* webpackChunkName: "pages/conductor/flagged-contacts/index" */))
const _bc64adda = () => interopDefault(import('../pages/conductor/mini-markets/index.vue' /* webpackChunkName: "pages/conductor/mini-markets/index" */))
const _6e7fb284 = () => interopDefault(import('../pages/conductor/profession-page-modules/index.vue' /* webpackChunkName: "pages/conductor/profession-page-modules/index" */))
const _e2fa0cea = () => interopDefault(import('../pages/conductor/zones/index.vue' /* webpackChunkName: "pages/conductor/zones/index" */))
const _31a3dc09 = () => interopDefault(import('../pages/conductor/profession-groups/index.vue' /* webpackChunkName: "pages/conductor/profession-groups/index" */))
const _3894910a = () => interopDefault(import('../pages/conductor/professions/index.vue' /* webpackChunkName: "pages/conductor/professions/index" */))
const _573e5870 = () => interopDefault(import('../pages/conductor/services/index.vue' /* webpackChunkName: "pages/conductor/services/index" */))
const _3cbda5b6 = () => interopDefault(import('../pages/conductor/service-types/index.vue' /* webpackChunkName: "pages/conductor/service-types/index" */))
const _ed04c8f4 = () => interopDefault(import('../pages/conductor/superadmin/index.vue' /* webpackChunkName: "pages/conductor/superadmin/index" */))
const _578434b1 = () => interopDefault(import('../pages/conductor/profession-task-pages/index.vue' /* webpackChunkName: "pages/conductor/profession-task-pages/index" */))
const _0fb64753 = () => interopDefault(import('../pages/conductor/virtual-phone-prefixes/index.vue' /* webpackChunkName: "pages/conductor/virtual-phone-prefixes/index" */))
const _10d5d35f = () => interopDefault(import('../pages/conductor/mini-market-teams/index.vue' /* webpackChunkName: "pages/conductor/mini-market-teams/index" */))
const _420dbb5f = () => interopDefault(import('../pages/visszajelzes/koszonjuk.vue' /* webpackChunkName: "pages/visszajelzes/koszonjuk" */))
const _78618004 = () => interopDefault(import('../pages/demo/price-offers/new/index.vue' /* webpackChunkName: "pages/demo/price-offers/new/index" */))
const _0034270a = () => interopDefault(import('../pages/my-account/price-offers/new/index.vue' /* webpackChunkName: "pages/my-account/price-offers/new/index" */))
const _588fe78e = () => interopDefault(import('../pages/tema/sos/festes.vue' /* webpackChunkName: "pages/tema/sos/festes" */))
const _661c0f0a = () => interopDefault(import('../pages/tema/sos/koszonjuk.vue' /* webpackChunkName: "pages/tema/sos/koszonjuk" */))
const _45db412a = () => interopDefault(import('../pages/conductor/tenders/judge/index.vue' /* webpackChunkName: "pages/conductor/tenders/judge/index" */))
const _328e023e = () => interopDefault(import('../pages/conductor/tenders/create/index.vue' /* webpackChunkName: "pages/conductor/tenders/create/index" */))
const _2cea8d20 = () => interopDefault(import('../pages/conductor/tenders/list/index.vue' /* webpackChunkName: "pages/conductor/tenders/list/index" */))
const _6221f553 = () => interopDefault(import('../pages/conductor/request-tender-page-modules/funnel/index.vue' /* webpackChunkName: "pages/conductor/request-tender-page-modules/funnel/index" */))
const _038e7f19 = () => interopDefault(import('../pages/conductor/request-tender-page-modules/create/index.vue' /* webpackChunkName: "pages/conductor/request-tender-page-modules/create/index" */))
const _5fb1b120 = () => interopDefault(import('../pages/conductor/finance-transactions/import/index.vue' /* webpackChunkName: "pages/conductor/finance-transactions/import/index" */))
const _0c144b2c = () => interopDefault(import('../pages/conductor/settings/create/index.vue' /* webpackChunkName: "pages/conductor/settings/create/index" */))
const _7085908e = () => interopDefault(import('../pages/conductor/blog/articles/index.vue' /* webpackChunkName: "pages/conductor/blog/articles/index" */))
const _8ef50b2c = () => interopDefault(import('../pages/conductor/blog/tags/index.vue' /* webpackChunkName: "pages/conductor/blog/tags/index" */))
const _18885b3a = () => interopDefault(import('../pages/conductor/blog/collections/index.vue' /* webpackChunkName: "pages/conductor/blog/collections/index" */))
const _a4ff604a = () => interopDefault(import('../pages/conductor/leads/index.vue' /* webpackChunkName: "pages/conductor/leads/index" */))
const _16045c6e = () => interopDefault(import('../pages/conductor/job-feeds/index.vue' /* webpackChunkName: "pages/conductor/job-feeds/index" */))
const _5ab74088 = () => interopDefault(import('../pages/conductor/crm-professional-ticket-statuses/index.vue' /* webpackChunkName: "pages/conductor/crm-professional-ticket-statuses/index" */))
const _17cd1c35 = () => interopDefault(import('../pages/conductor/email-templates/create/index.vue' /* webpackChunkName: "pages/conductor/email-templates/create/index" */))
const _e4364956 = () => interopDefault(import('../pages/conductor/notifications/create/index.vue' /* webpackChunkName: "pages/conductor/notifications/create/index" */))
const _c848ac6c = () => interopDefault(import('../pages/conductor/faqs/groups/index.vue' /* webpackChunkName: "pages/conductor/faqs/groups/index" */))
const _ca1ac21c = () => interopDefault(import('../pages/conductor/faqs/create/index.vue' /* webpackChunkName: "pages/conductor/faqs/create/index" */))
const _004c27ca = () => interopDefault(import('../pages/conductor/faqs/manage/index.vue' /* webpackChunkName: "pages/conductor/faqs/manage/index" */))
const _cf2dedec = () => interopDefault(import('../pages/conductor/person-event-log-types/create/index.vue' /* webpackChunkName: "pages/conductor/person-event-log-types/create/index" */))
const _4e4d78c6 = () => interopDefault(import('../pages/conductor/inspirations/create/index.vue' /* webpackChunkName: "pages/conductor/inspirations/create/index" */))
const _52dca455 = () => interopDefault(import('../pages/conductor/subcounties/create/index.vue' /* webpackChunkName: "pages/conductor/subcounties/create/index" */))
const _3a940d4e = () => interopDefault(import('../pages/conductor/legal-documents/create/index.vue' /* webpackChunkName: "pages/conductor/legal-documents/create/index" */))
const _e44ec76e = () => interopDefault(import('../pages/conductor/flagged-contacts/create/index.vue' /* webpackChunkName: "pages/conductor/flagged-contacts/create/index" */))
const _032c5364 = () => interopDefault(import('../pages/conductor/mini-markets/create/index.vue' /* webpackChunkName: "pages/conductor/mini-markets/create/index" */))
const _ecbcabf0 = () => interopDefault(import('../pages/conductor/monitoring/funnels/index.vue' /* webpackChunkName: "pages/conductor/monitoring/funnels/index" */))
const _7b8c98e6 = () => interopDefault(import('../pages/conductor/zones/positions/index.vue' /* webpackChunkName: "pages/conductor/zones/positions/index" */))
const _5ba78ed6 = () => interopDefault(import('../pages/conductor/zones/create/index.vue' /* webpackChunkName: "pages/conductor/zones/create/index" */))
const _420efad0 = () => interopDefault(import('../pages/conductor/profession-groups/create/index.vue' /* webpackChunkName: "pages/conductor/profession-groups/create/index" */))
const _691f7a34 = () => interopDefault(import('../pages/conductor/professions/create/index.vue' /* webpackChunkName: "pages/conductor/professions/create/index" */))
const _1518d75e = () => interopDefault(import('../pages/conductor/services/create/index.vue' /* webpackChunkName: "pages/conductor/services/create/index" */))
const _442ef9fc = () => interopDefault(import('../pages/conductor/service-types/create/index.vue' /* webpackChunkName: "pages/conductor/service-types/create/index" */))
const _d2099e20 = () => interopDefault(import('../pages/conductor/profession-task-pages/select/index.vue' /* webpackChunkName: "pages/conductor/profession-task-pages/select/index" */))
const _1f6ac620 = () => interopDefault(import('../pages/conductor/profession-task-pages/create/index.vue' /* webpackChunkName: "pages/conductor/profession-task-pages/create/index" */))
const _5d10b95e = () => interopDefault(import('../pages/conductor/virtual-phone-prefix-assignments/index.vue' /* webpackChunkName: "pages/conductor/virtual-phone-prefix-assignments/index" */))
const _70cde78f = () => interopDefault(import('../pages/conductor/virtual-phone-prefix-rules/index.vue' /* webpackChunkName: "pages/conductor/virtual-phone-prefix-rules/index" */))
const _42d082fc = () => interopDefault(import('../pages/conductor/mini-market-teams/create/index.vue' /* webpackChunkName: "pages/conductor/mini-market-teams/create/index" */))
const _c6fec31a = () => interopDefault(import('../pages/conductor/blog/articles/create/index.vue' /* webpackChunkName: "pages/conductor/blog/articles/create/index" */))
const _5efb2517 = () => interopDefault(import('../pages/conductor/blog/tags/create/index.vue' /* webpackChunkName: "pages/conductor/blog/tags/create/index" */))
const _721e8b72 = () => interopDefault(import('../pages/conductor/blog/collections/create/index.vue' /* webpackChunkName: "pages/conductor/blog/collections/create/index" */))
const _4c802d6f = () => interopDefault(import('../pages/conductor/lead-tasks/index.vue' /* webpackChunkName: "pages/conductor/lead-tasks/index" */))
const _cec07096 = () => interopDefault(import('../pages/conductor/lead-owners/index.vue' /* webpackChunkName: "pages/conductor/lead-owners/index" */))
const _c0da5596 = () => interopDefault(import('../pages/conductor/lead-statuses/index.vue' /* webpackChunkName: "pages/conductor/lead-statuses/index" */))
const _7a92e9b7 = () => interopDefault(import('../pages/conductor/faqs/groups/create/index.vue' /* webpackChunkName: "pages/conductor/faqs/groups/create/index" */))
const _29599452 = () => interopDefault(import('../pages/conductor/virtual-phone-prefix-rules/create/index.vue' /* webpackChunkName: "pages/conductor/virtual-phone-prefix-rules/create/index" */))
const _1d4b0d3b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6212c26f = () => interopDefault(import('../pages/landing/request-tender/profession-task/_professionTaskSeoName.vue' /* webpackChunkName: "pages/landing/request-tender/profession-task/_professionTaskSeoName" */))
const _11e7b479 = () => interopDefault(import('../pages/conductor/blog/articles/_id/index.vue' /* webpackChunkName: "pages/conductor/blog/articles/_id/index" */))
const _21e75055 = () => interopDefault(import('../pages/conductor/blog/tags/_id/index.vue' /* webpackChunkName: "pages/conductor/blog/tags/_id/index" */))
const _10ed4925 = () => interopDefault(import('../pages/conductor/blog/collections/_id/index.vue' /* webpackChunkName: "pages/conductor/blog/collections/_id/index" */))
const _6caff574 = () => interopDefault(import('../pages/conductor/leads/_id/index.vue' /* webpackChunkName: "pages/conductor/leads/_id/index" */))
const _3196e034 = () => interopDefault(import('../pages/conductor/job-feeds/_id/index.vue' /* webpackChunkName: "pages/conductor/job-feeds/_id/index" */))
const _05d6cfb5 = () => interopDefault(import('../pages/conductor/faqs/groups/_id/index.vue' /* webpackChunkName: "pages/conductor/faqs/groups/_id/index" */))
const _783aa2fa = () => interopDefault(import('../pages/conductor/virtual-phone-prefix-rules/_id/index.vue' /* webpackChunkName: "pages/conductor/virtual-phone-prefix-rules/_id/index" */))
const _a50d881c = () => interopDefault(import('../pages/blog/tag/_tagSeoName.vue' /* webpackChunkName: "pages/blog/tag/_tagSeoName" */))
const _33530cd6 = () => interopDefault(import('../pages/blog/collection/_collectionSeoName.vue' /* webpackChunkName: "pages/blog/collection/_collectionSeoName" */))
const _25c6579a = () => interopDefault(import('../pages/blog/profession/_professionSeoName.vue' /* webpackChunkName: "pages/blog/profession/_professionSeoName" */))
const _4ca8bc10 = () => interopDefault(import('../pages/blog/professionTask/_professionTaskSeoName.vue' /* webpackChunkName: "pages/blog/professionTask/_professionTaskSeoName" */))
const _914b5e6c = () => interopDefault(import('../pages/demo/price-offer/_publicId/index.vue' /* webpackChunkName: "pages/demo/price-offer/_publicId/index" */))
const _defd20c4 = () => interopDefault(import('../pages/demo/price-offers/_id/index.vue' /* webpackChunkName: "pages/demo/price-offers/_id/index" */))
const _1805dc15 = () => interopDefault(import('../pages/my-account/price-offers/_id/index.vue' /* webpackChunkName: "pages/my-account/price-offers/_id/index" */))
const _0b387cfc = () => interopDefault(import('../pages/my-account/settings/_highlightedSetting.vue' /* webpackChunkName: "pages/my-account/settings/_highlightedSetting" */))
const _55c78716 = () => interopDefault(import('../pages/my-account/subscription/_serviceTypeSeoName/index.vue' /* webpackChunkName: "pages/my-account/subscription/_serviceTypeSeoName/index" */))
const _533c1a7c = () => interopDefault(import('../pages/my-account/my-job/_personTenderId.vue' /* webpackChunkName: "pages/my-account/my-job/_personTenderId" */))
const _2e43f44e = () => interopDefault(import('../pages/my-account/plans/_planPublicId/index.vue' /* webpackChunkName: "pages/my-account/plans/_planPublicId/index" */))
const _771b8445 = () => interopDefault(import('../pages/my-account/designers/_designerId/index.vue' /* webpackChunkName: "pages/my-account/designers/_designerId/index" */))
const _1ffae464 = () => interopDefault(import('../pages/inspiration/profession/_professionSeoName.vue' /* webpackChunkName: "pages/inspiration/profession/_professionSeoName" */))
const _67413166 = () => interopDefault(import('../pages/inspiration/profession-task/_professionTaskSeoName.vue' /* webpackChunkName: "pages/inspiration/profession-task/_professionTaskSeoName" */))
const _b1478e8a = () => interopDefault(import('../pages/landing/request-tender/_professionSeoName.vue' /* webpackChunkName: "pages/landing/request-tender/_professionSeoName" */))
const _65f06c70 = () => interopDefault(import('../pages/salary-checker/average/_professionSeoName/index.vue' /* webpackChunkName: "pages/salary-checker/average/_professionSeoName/index" */))
const _3979a7c4 = () => interopDefault(import('../pages/questions' /* webpackChunkName: "pages/questions/profession/_profession/index" */))
const _2632dc8e = () => interopDefault(import('../pages/conductor/tenders/_id/index.vue' /* webpackChunkName: "pages/conductor/tenders/_id/index" */))
const _7db80593 = () => interopDefault(import('../pages/conductor/request-tender-page-modules/_id/index.vue' /* webpackChunkName: "pages/conductor/request-tender-page-modules/_id/index" */))
const _4bb4ea60 = () => interopDefault(import('../pages/conductor/settings/_id/index.vue' /* webpackChunkName: "pages/conductor/settings/_id/index" */))
const _01104412 = () => interopDefault(import('../pages/conductor/email-templates/_id/index.vue' /* webpackChunkName: "pages/conductor/email-templates/_id/index" */))
const _3c0592a5 = () => interopDefault(import('../pages/conductor/ratings/_id/index.vue' /* webpackChunkName: "pages/conductor/ratings/_id/index" */))
const _46251a52 = () => interopDefault(import('../pages/conductor/notifications/_id/index.vue' /* webpackChunkName: "pages/conductor/notifications/_id/index" */))
const _4f6001ed = () => interopDefault(import('../pages/conductor/persons/_id/index.vue' /* webpackChunkName: "pages/conductor/persons/_id/index" */))
const _adc2c74c = () => interopDefault(import('../pages/conductor/faqs/_id/index.vue' /* webpackChunkName: "pages/conductor/faqs/_id/index" */))
const _0c562942 = () => interopDefault(import('../pages/conductor/person-event-log-types/_id/index.vue' /* webpackChunkName: "pages/conductor/person-event-log-types/_id/index" */))
const _213b99f4 = () => interopDefault(import('../pages/conductor/inspirations/_id/index.vue' /* webpackChunkName: "pages/conductor/inspirations/_id/index" */))
const _b99b6c52 = () => interopDefault(import('../pages/conductor/subcounties/_id/index.vue' /* webpackChunkName: "pages/conductor/subcounties/_id/index" */))
const _85e6995a = () => interopDefault(import('../pages/conductor/legal-documents/_id/index.vue' /* webpackChunkName: "pages/conductor/legal-documents/_id/index" */))
const _240e26fc = () => interopDefault(import('../pages/conductor/questions/_id/index.vue' /* webpackChunkName: "pages/conductor/questions/_id/index" */))
const _55f67663 = () => interopDefault(import('../pages/conductor/flagged-contacts/_id/index.vue' /* webpackChunkName: "pages/conductor/flagged-contacts/_id/index" */))
const _8e93fb04 = () => interopDefault(import('../pages/conductor/mini-markets/_id/index.vue' /* webpackChunkName: "pages/conductor/mini-markets/_id/index" */))
const _9e435214 = () => interopDefault(import('../pages/conductor/zones/_id/index.vue' /* webpackChunkName: "pages/conductor/zones/_id/index" */))
const _3badca74 = () => interopDefault(import('../pages/conductor/profession-groups/_id/index.vue' /* webpackChunkName: "pages/conductor/profession-groups/_id/index" */))
const _dcbec634 = () => interopDefault(import('../pages/conductor/professions/_id/index.vue' /* webpackChunkName: "pages/conductor/professions/_id/index" */))
const _4554894a = () => interopDefault(import('../pages/conductor/services/_id/index.vue' /* webpackChunkName: "pages/conductor/services/_id/index" */))
const _1c252d90 = () => interopDefault(import('../pages/conductor/service-types/_id/index.vue' /* webpackChunkName: "pages/conductor/service-types/_id/index" */))
const _52e18f1c = () => interopDefault(import('../pages/conductor/profession-task-pages/_id/index.vue' /* webpackChunkName: "pages/conductor/profession-task-pages/_id/index" */))
const _906fb26c = () => interopDefault(import('../pages/conductor/mini-market-teams/_id/index.vue' /* webpackChunkName: "pages/conductor/mini-market-teams/_id/index" */))
const _3f691353 = () => interopDefault(import('../pages/salary-checker/average/_professionSeoName/jobs/index.vue' /* webpackChunkName: "pages/salary-checker/average/_professionSeoName/jobs/index" */))
const _77a53804 = () => interopDefault(import('../pages/close-tender/_personTenderId.vue' /* webpackChunkName: "pages/close-tender/_personTenderId" */))
const _3e34b71c = () => interopDefault(import('../pages/request-for-tender/_activeTab.vue' /* webpackChunkName: "pages/request-for-tender/_activeTab" */))
const _d47cdb10 = () => interopDefault(import('../pages/price-offer/_publicId/index.vue' /* webpackChunkName: "pages/price-offer/_publicId/index" */))
const _8b1fad3c = () => interopDefault(import('../pages/prices/_professionTask.vue' /* webpackChunkName: "pages/prices/_professionTask" */))
const _1a9412cc = () => interopDefault(import('../pages/arcsekkolo/_professionSeoName/index.vue' /* webpackChunkName: "pages/arcsekkolo/_professionSeoName/index" */))
const _759b63ea = () => interopDefault(import('../pages/blog/_articleSeoName.vue' /* webpackChunkName: "pages/blog/_articleSeoName" */))
const _89129daa = () => interopDefault(import('../pages/documents/_type.vue' /* webpackChunkName: "pages/documents/_type" */))
const _62fd8224 = () => interopDefault(import('../pages/inspiration/_inspirationSeoName/index.vue' /* webpackChunkName: "pages/inspiration/_inspirationSeoName/index" */))
const _225498fb = () => interopDefault(import('../pages/landing/_slug.vue' /* webpackChunkName: "pages/landing/_slug" */))
const _00df2ea8 = () => interopDefault(import('../pages/counties/_county/index.vue' /* webpackChunkName: "pages/counties/_county/index" */))
const _5981deac = () => interopDefault(import('../pages/partner-ajanlatkeres/_partnerCode.vue' /* webpackChunkName: "pages/partner-ajanlatkeres/_partnerCode" */))
const _58c66acc = () => interopDefault(import('../pages/projects/_id.vue' /* webpackChunkName: "pages/projects/_id" */))
const _40a8adb6 = () => interopDefault(import('../pages/professional/_professionalSeoName/index.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/index" */))
const _8f771e38 = () => interopDefault(import('../pages/professionals/_profession/index.vue' /* webpackChunkName: "pages/professionals/_profession/index" */))
const _1536bb6f = () => interopDefault(import('../pages/questions/_questionSeoName/index.vue' /* webpackChunkName: "pages/questions/_questionSeoName/index" */))
const _ee6be1fa = () => interopDefault(import('../pages/profession/_professionGroup/index.vue' /* webpackChunkName: "pages/profession/_professionGroup/index" */))
const _c819e8c6 = () => interopDefault(import('../pages/tender/_tenderId/index.vue' /* webpackChunkName: "pages/tender/_tenderId/index" */))
const _3ff97b60 = () => interopDefault(import('../pages/plan/_planPublicId/index.vue' /* webpackChunkName: "pages/plan/_planPublicId/index" */))
const _a1b16392 = () => interopDefault(import('../pages/valassz/_decisionTestSeoName.vue' /* webpackChunkName: "pages/valassz/_decisionTestSeoName" */))
const _502ba96f = () => interopDefault(import('../pages/tender/_tenderId/specify/index.vue' /* webpackChunkName: "pages/tender/_tenderId/specify/index" */))
const _2b383690 = () => interopDefault(import('../pages/professionals/_profession/events.js' /* webpackChunkName: "pages/professionals/_profession/events" */))
const _d01b40a8 = () => interopDefault(import('../pages/professional/_professionalSeoName/rating/index.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/rating/index" */))
const _23a89800 = () => interopDefault(import('../pages/professional/_professionalSeoName/admin/balance.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/admin/balance" */))
const _08378e5c = () => interopDefault(import('../pages/professional/_professionalSeoName/admin/merge.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/admin/merge" */))
const _006ec025 = () => interopDefault(import('../pages/professional/_professionalSeoName/admin/person-event-log.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/admin/person-event-log" */))
const _269d9be8 = () => interopDefault(import('../pages/professional/_professionalSeoName/admin/transfers.vue' /* webpackChunkName: "pages/professional/_professionalSeoName/admin/transfers" */))
const _c108683a = () => interopDefault(import('../pages/tender/_tenderId/specify/_activeTab.vue' /* webpackChunkName: "pages/tender/_tenderId/specify/_activeTab" */))
const _15c88c18 = () => interopDefault(import('../pages/professionals/_profession/szakivalaszol/_questionSeoName.vue' /* webpackChunkName: "pages/professionals/_profession/szakivalaszol/_questionSeoName" */))
const _3ebeabe0 = () => interopDefault(import('../pages/arcsekkolo/_professionSeoName/_priceTagSeoName.vue' /* webpackChunkName: "pages/arcsekkolo/_professionSeoName/_priceTagSeoName" */))
const _e9c1468c = () => interopDefault(import('../pages/price-calculator/_professionTask/_step.vue' /* webpackChunkName: "pages/price-calculator/_professionTask/_step" */))
const _4b7e0f5e = () => interopDefault(import('../pages/inspiration/_inspirationSeoName/_pictureSeoName/index.vue' /* webpackChunkName: "pages/inspiration/_inspirationSeoName/_pictureSeoName/index" */))
const _4c672042 = () => interopDefault(import('../pages/professionals/_profession/_city/index.vue' /* webpackChunkName: "pages/professionals/_profession/_city/index" */))
const _a8282a72 = () => interopDefault(import('../pages/counties/_county/_city/_subCity.vue' /* webpackChunkName: "pages/counties/_county/_city/_subCity" */))
const _cb850e72 = () => interopDefault(import('../pages/professionals/_profession/_city/index' /* webpackChunkName: "pages/professionals/_profession/_parentCity/_city/index" */))
const _03cf66c8 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ajanlatkeres",
    component: _5a727380,
    name: "requestForTender___hu-HU"
  }, {
    path: "/ajanlatkeroi-regisztracio",
    component: _5751fb74,
    name: "customerRegistrationPage___hu-HU"
  }, {
    path: "/arajanlatkeszito",
    component: _14741178,
    name: "priceOfferLandingPage___hu-HU"
  }, {
    path: "/arajanlatkeszito-regisztracio",
    component: _b26bb110,
    name: "priceOfferRegistrationPage___hu-HU"
  }, {
    path: "/arak",
    component: _71fcfa18,
    name: "pricesPage___hu-HU"
  }, {
    path: "/aszf",
    component: _0a6a041a,
    name: "terms___hu-HU"
  }, {
    path: "/auto-login",
    component: _0b07dfb5,
    name: "auto-login___hu-HU"
  }, {
    path: "/belepes",
    component: _908b9d56,
    name: "login___hu-HU"
  }, {
    path: "/blog",
    component: _48caa40c,
    name: "blogLandingPage___hu-HU"
  }, {
    path: "/dokumentumok",
    component: _a380e538,
    name: "documentsIndexPage___hu-HU"
  }, {
    path: "/elso-belepes",
    component: _6495c202,
    name: "elso-belepes___hu-HU"
  }, {
    path: "/email-megerosites",
    component: _2d173a0a,
    name: "emailConfirmPage___hu-HU"
  }, {
    path: "/health-check",
    component: _2a3e2504,
    name: "health-check___hu-HU"
  }, {
    path: "/heroku-login",
    component: _fb72cc32,
    name: "heroku-login___hu-HU"
  }, {
    path: "/inspiracio",
    component: _47206ed6,
    name: "inspirationLandingPage___hu-HU"
  }, {
    path: "/karrier",
    component: _d816bdb0,
    name: "careerPage___hu-HU"
  }, {
    path: "/koszonjuk",
    component: _0b624f82,
    name: "koszonjuk___hu-HU"
  }, {
    path: "/leiratkozas",
    component: _733c9bff,
    name: "leiratkozas___hu-HU"
  }, {
    path: "/munkaertesito",
    component: _dd5630b6,
    name: "jobNotificationPage___hu-HU"
  }, {
    path: "/nincs-jelszo",
    component: _61aa34d3,
    name: "noPassword___hu-HU"
  }, {
    path: "/oauth-regisztracio",
    component: _3b403203,
    name: "oauthRegisterPage___hu-HU"
  }, {
    path: "/registration",
    component: _b95be240,
    name: "registrationPageRedirect___hu-HU",
    children: [{
      path: "/regisztracio",
      component: _524fed63,
      name: "registrationPage___hu-HU"
    }, {
      path: "/regisztracio/bemutatkozas",
      component: _a1700f48,
      name: "registrationStepIntroduction___hu-HU"
    }, {
      path: "/regisztracio/email",
      component: _500d6820,
      name: "registrationStepEmail___hu-HU"
    }, {
      path: "/regisztracio/jelszo",
      component: _ad4c4dc6,
      name: "registrationStepPassword___hu-HU"
    }, {
      path: "/regisztracio/jobfeed",
      component: _b5fd23a2,
      name: "registrationJobfeed___hu-HU"
    }, {
      path: "/regisztracio/nev",
      component: _35ab188d,
      name: "registrationStepName___hu-HU"
    }, {
      path: "/regisztracio/profilkep",
      component: _56af3edc,
      name: "registrationStepPicture___hu-HU"
    }, {
      path: "/regisztracio/siker",
      component: _c475fd52,
      name: "registrationStepSuccess___hu-HU"
    }, {
      path: "/regisztracio/szakmak",
      component: _735f8a6a,
      name: "registrationStepProfession___hu-HU"
    }, {
      path: "/regisztracio/szamlakepesseg",
      component: _af78cffe,
      name: "registrationStepInvoice___hu-HU"
    }, {
      path: "/regisztracio/telefonszam",
      component: _6a739f42,
      name: "registrationStepPhone___hu-HU"
    }, {
      path: "/regisztracio/varos",
      component: _6615c126,
      name: "registrationStepCity___hu-HU"
    }, {
      path: "/regisztracio/:_",
      component: _175a9af0,
      name: "registration-all___hu-HU"
    }]
  }, {
    path: "/szakifizetesek",
    component: _31ae2552,
    name: "salariesPage___hu-HU"
  }, {
    path: "/szakifizu",
    component: _0db28748,
    name: "salaryCheckerPage___hu-HU"
  }, {
    path: "/szakivalaszol",
    component: _565205b9,
    name: "questionsPage___hu-HU"
  }, {
    path: "/szakma",
    component: _317cd4b4,
    name: "professionsLandingPage___hu-HU"
  }, {
    path: "/szerzodesmintak",
    component: _3dcf3a3e,
    name: "szerzodesmintak___hu-HU"
  }, {
    path: "/telepules",
    component: _757c5333,
    name: "citiesPage___hu-HU"
  }, {
    path: "/uj-jelszo",
    component: _2c31a3dc,
    name: "newPasswordPage___hu-HU"
  }, {
    path: "/uj-szakik",
    component: _06fc26ab,
    name: "newProfessionalsPage___hu-HU"
  }, {
    path: "/velemeny",
    component: _6e9a3916,
    name: "velemeny___hu-HU"
  }, {
    path: "/vezerlo",
    component: _4406f213,
    name: "conductorIndexPage___hu-HU"
  }, {
    path: "/visszajelzes",
    component: _b6d5b74a,
    name: "visszajelzes___hu-HU"
  }, {
    path: "/components/buttons",
    component: _7aa3a8ef,
    name: "components-buttons___hu-HU"
  }, {
    path: "/components/inputs",
    component: _20d5d42a,
    name: "components-inputs___hu-HU"
  }, {
    path: "/components/misc",
    component: _4b5bd1ee,
    name: "components-misc___hu-HU"
  }, {
    path: "/demo/arajanlatok",
    component: _219ca633,
    name: "demoPriceOffersIndexPage___hu-HU"
  }, {
    path: "/dokumentumok/suti-tajekoztato",
    component: _b46cabbe,
    name: "documentsCookiesPage___hu-HU"
  }, {
    path: "/fiokom/ajanlatkereseim",
    component: _62aad9cd,
    name: "myTenders___hu-HU"
  }, {
    path: "/fiokom/araim",
    component: _3c131fce,
    name: "addPricesPage___hu-HU"
  }, {
    path: "/fiokom/arajanlatok",
    component: _a58033ac,
    name: "myPriceOffersIndexPage___hu-HU"
  }, {
    path: "/fiokom/csempetervezo",
    component: _0c8d3e11,
    name: "tileDesignerPage___hu-HU"
  }, {
    path: "/fiokom/elofizetes",
    component: _6e41ee2c,
    name: "subscriptionPage___hu-HU"
  }, {
    path: "/fiokom/ertekeleseim",
    component: _64fb9938,
    name: "RatingsPage___hu-HU"
  }, {
    path: "/fiokom/folyamatban-levo-munkaim",
    component: _8d87a6a6,
    name: "boughtTendersPage___hu-HU"
  }, {
    path: "/fiokom/kedvenceim",
    component: _81d52a8e,
    name: "favourites___hu-HU"
  }, {
    path: "/fiokom/lezart-munkaim",
    component: _07965c84,
    name: "closedTendersPage___hu-HU"
  }, {
    path: "/fiokom/megnyert-munkaim",
    component: _5b61cb88,
    name: "wonTendersPage___hu-HU"
  }, {
    path: "/fiokom/megszerezheto-munkaim",
    component: _d066ed6a,
    name: "buyTendersPage___hu-HU"
  }, {
    path: "/fiokom/referenciaim",
    component: _81489a52,
    name: "references___hu-HU"
  }, {
    path: "/fiokom/termek-katalogus",
    component: _6de9bfe2,
    name: "productCatalogPage___hu-HU"
  }, {
    path: "/fiokom/tervezok",
    component: _4f53eb62,
    name: "designersHubPage___hu-HU"
  }, {
    path: "/fizetes/folyamatban",
    component: _77b7d248,
    name: "fizetes-folyamatban___hu-HU"
  }, {
    path: "/fizetes/sikeres",
    component: _c4e37d84,
    name: "fizetes-sikeres___hu-HU"
  }, {
    path: "/fizetes/sikertelen",
    component: _bd5b12b8,
    name: "fizetes-sikertelen___hu-HU"
  }, {
    path: "/salary-checker/fizuk",
    component: _61e9e5b8,
    name: "salary-checker-fizuk___hu-HU"
  }, {
    path: "/static/gyik",
    component: _53e0e15f,
    name: "faqPage___hu-HU"
  }, {
    path: "/static/rolunk",
    component: _ede13eea,
    name: "aboutUs___hu-HU"
  }, {
    path: "/szakivalaszol/szakma",
    redirect: "/questions"
  }, {
    path: "/szakivalaszol/tevekenyseg",
    redirect: "/questions"
  }, {
    path: "/szakivalaszol/uj-kerdes",
    component: _4a2811df,
    name: "addQuestionPage___hu-HU"
  }, {
    path: "/velemeny/koszonjuk",
    component: _d6bb450e,
    name: "velemeny-koszonjuk___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkeresek",
    component: _512be9ba,
    name: "conductorTendersIndexPage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkero-modulok",
    component: _450e7ea8,
    name: "conductorRequestTenderPageModulesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/beallitasok",
    component: _94a05c16,
    name: "conductorSettingsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/blog",
    component: _bf17f398,
    name: "conductorBlogIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm",
    component: _531002bc,
    name: "conductorCrmIndexPage___hu-HU"
  }, {
    path: "/vezerlo/email-sablonok",
    component: _2f32290c,
    name: "conductorEmailTemplatesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/ertekelesek",
    component: _424164ba,
    name: "conductorRatingsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/ertesitesek",
    component: _bd15a428,
    name: "conductorNotificationsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/felhasznalok",
    component: _6a86b802,
    name: "conductorPersonsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/fooldal-modulok",
    component: _0f9857ff,
    name: "conductorFrontPageModulesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/gyik",
    component: _1b34de22,
    name: "conductorFaqsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/hirlevel-feliratkozasok",
    component: _5388a418,
    name: "conductorNewsletterSubscriptionsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/hivasnaplo-tipusok",
    component: _48105c52,
    name: "conductorPersonEventLogTypesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/inspiraciok",
    component: _b61144ca,
    name: "conductorInspirationsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/jarasok",
    component: _01bd84ec,
    name: "conductorSubcountiesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/jogi-dokumentumok",
    component: _47600c68,
    name: "conductorLegalDocumentsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/kedvencek",
    component: _0785ba66,
    name: "conductorPersonFavouritesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/kerdesek",
    component: _411086de,
    name: "conductorQuestionsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/megjelolt-kapcsolatok",
    component: _2d45d778,
    name: "conductorFlaggedContactsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/minipiacok",
    component: _bc64adda,
    name: "conductorMiniMarketsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakemberek-modulok",
    component: _6e7fb284,
    name: "conductorProfessionPageModulesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakma-zonak",
    component: _e2fa0cea,
    name: "conductorZonesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakmacsoportok",
    component: _31a3dc09,
    name: "conductorProfessionGroupsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakmak",
    component: _3894910a,
    name: "conductorProfessionsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatasok",
    component: _573e5870,
    name: "conductorServicesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatastipusok",
    component: _3cbda5b6,
    name: "conductorserviceTypesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szuperadmin",
    component: _ed04c8f4,
    name: "conductorSuperadminIndexPage___hu-HU"
  }, {
    path: "/vezerlo/tevekenyseg-oldalak",
    component: _578434b1,
    name: "conductorProfessionTaskPagesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/virtualis-telefonszamok",
    component: _0fb64753,
    name: "conductorVirtualPhonePrefixesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/zona-csapatok",
    component: _10d5d35f,
    name: "conductorMiniMarketTeamsIndexPage___hu-HU"
  }, {
    path: "/visszajelzes/koszonjuk",
    component: _420dbb5f,
    name: "visszajelzes-koszonjuk___hu-HU"
  }, {
    path: "/demo/arajanlatok/uj",
    component: _78618004,
    name: "demoPriceOffersCreatePage___hu-HU"
  }, {
    path: "/fiokom/arajanlatok/uj",
    component: _0034270a,
    name: "priceOffersCreatePage___hu-HU"
  }, {
    path: "/tema/sos/festes",
    component: _588fe78e,
    name: "tema-sos-festes___hu-HU"
  }, {
    path: "/tema/sos/koszonjuk",
    component: _661c0f0a,
    name: "tema-sos-koszonjuk___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkeresek/biralas",
    component: _45db412a,
    name: "conductorTendersJudgeIndexPage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkeresek/letrehozas",
    component: _328e023e,
    name: "conductorTendersCreatePage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkeresek/lista",
    component: _2cea8d20,
    name: "conductorTendersListIndexPage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkero-modulok/konverzio",
    component: _6221f553,
    name: "conductorRequestTenderPageModulesFunnelPage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkero-modulok/letrehozas",
    component: _038e7f19,
    name: "conductorRequestTenderPageModulesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/banki-tranzakciok/importalas",
    component: _5fb1b120,
    name: "conductorFinanceTransactionsImportPage___hu-HU"
  }, {
    path: "/vezerlo/beallitasok/letrehozas",
    component: _0c144b2c,
    name: "conductorSettingsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/blog/cikkek",
    component: _7085908e,
    name: "conductorBlogArticlesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/blog/cimkek",
    component: _8ef50b2c,
    name: "conductorBlogTagsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/blog/gyujtemenyek",
    component: _18885b3a,
    name: "conductorBlogCollectionsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm/leadek",
    component: _a4ff604a,
    name: "conductorLeadsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm/munkaertesitok",
    component: _16045c6e,
    name: "conductorJobFeedsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm/szakember-statuszok",
    component: _5ab74088,
    name: "conductorCrmProfessionalTicketStatusesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/email-sablonok/letrehozas",
    component: _17cd1c35,
    name: "conductorEmailTemplatesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/ertesitesek/letrehozas",
    component: _e4364956,
    name: "conductorNotificationsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/gyik/csoportok",
    component: _c848ac6c,
    name: "conductorFaqsGroupsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/gyik/letrehozas",
    component: _ca1ac21c,
    name: "conductorFaqsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/gyik/sorrend",
    component: _004c27ca,
    name: "conductorFaqsManagePage___hu-HU"
  }, {
    path: "/vezerlo/hivasnaplo-tipusok/letrehozas",
    component: _cf2dedec,
    name: "conductorPersonEventLogTypesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/inspiraciok/letrehozas",
    component: _4e4d78c6,
    name: "conductorInspirationsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/jarasok/letrehozas",
    component: _52dca455,
    name: "conductorSubcountiesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/jogi-dokumentumok/letrehozas",
    component: _3a940d4e,
    name: "conductorLegalDocumentsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/megjelolt-kapcsolatok/letrehozas",
    component: _e44ec76e,
    name: "conductorFlaggedContactsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/minipiacok/letrehozas",
    component: _032c5364,
    name: "conductorMiniMarketsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/monitoring/trendek",
    component: _ecbcabf0,
    name: "conductorMonitoringFunnelsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakma-zonak/helyezesek",
    component: _7b8c98e6,
    name: "conductorZonePositionsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/szakma-zonak/letrehozas",
    component: _5ba78ed6,
    name: "conductorZonesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/szakmacsoportok/letrehozas",
    component: _420efad0,
    name: "conductorProfessionGroupsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/szakmak/letrehozas",
    component: _691f7a34,
    name: "conductorProfessionsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatasok/letrehozas",
    component: _1518d75e,
    name: "conductorServicesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatastipusok/letrehozas",
    component: _442ef9fc,
    name: "conductorServiceTypesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/tevekenyseg-oldalak/kivalasztas",
    component: _d2099e20,
    name: "conductorProfessionTaskPagesSelectPage___hu-HU"
  }, {
    path: "/vezerlo/tevekenyseg-oldalak/letrehozas",
    component: _1f6ac620,
    name: "conductorProfessionTaskPagesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/virtualis-telefonszamok/hozzarendelesek",
    component: _5d10b95e,
    name: "conductorVirtualPhonePrefixAssignmentsIndexPage___hu-HU"
  }, {
    path: "/vezerlo/virtualis-telefonszamok/szabalyok",
    component: _70cde78f,
    name: "conductorVirtualPhonePrefixRulesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/zona-csapatok/letrehozas",
    component: _42d082fc,
    name: "conductorMiniMarketTeamsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/blog/cikkek/letrehozas",
    component: _c6fec31a,
    name: "conductorBlogArticlesCreatePage___hu-HU"
  }, {
    path: "/vezerlo/blog/cimkek/letrehozas",
    component: _5efb2517,
    name: "conductorBlogTagsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/blog/gyujtemenyek/letrehozas",
    component: _721e8b72,
    name: "conductorBlogCollectionsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/crm/leadek/feladatok",
    component: _4c802d6f,
    name: "conductorLeadTasksIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm/leadek/felelosok",
    component: _cec07096,
    name: "conductorLeadOwnersIndexPage___hu-HU"
  }, {
    path: "/vezerlo/crm/leadek/statuszok",
    component: _c0da5596,
    name: "conductorLeadStatusesIndexPage___hu-HU"
  }, {
    path: "/vezerlo/gyik/csoportok/letrehozas",
    component: _7a92e9b7,
    name: "conductorFaqsGroupsCreatePage___hu-HU"
  }, {
    path: "/vezerlo/virtualis-telefonszamok/szabalyok/letrehozas",
    component: _29599452,
    name: "conductorVirtualPhonePrefixRulesCreatePage___hu-HU"
  }, {
    path: "/",
    component: _1d4b0d3b,
    name: "indexPage___hu-HU"
  }, {
    path: "/landing/ajanlatkeres/tevekenyseg/:professionTaskSeoName",
    component: _6212c26f,
    name: "landing-request-tender-profession-task-professionTaskSeoName___hu-HU"
  }, {
    path: "/vezerlo/blog/cikkek/:id",
    component: _11e7b479,
    name: "conductorBlogArticlesEditPage___hu-HU"
  }, {
    path: "/vezerlo/blog/cimkek/:id",
    component: _21e75055,
    name: "conductorBlogTagsEditPage___hu-HU"
  }, {
    path: "/vezerlo/blog/gyujtemenyek/:id",
    component: _10ed4925,
    name: "conductorBlogCollectionsEditPage___hu-HU"
  }, {
    path: "/vezerlo/crm/leadek/:id",
    component: _6caff574,
    name: "conductorLeadsViewPage___hu-HU"
  }, {
    path: "/vezerlo/crm/munkaertesitok/:id",
    component: _3196e034,
    name: "conductorJobFeedsViewPage___hu-HU"
  }, {
    path: "/vezerlo/gyik/csoportok/:id",
    component: _05d6cfb5,
    name: "conductorFaqsGroupsEditPage___hu-HU"
  }, {
    path: "/vezerlo/virtualis-telefonszamok/szabalyok/:id",
    component: _783aa2fa,
    name: "conductorVirtualPhonePrefixRulesEditPage___hu-HU"
  }, {
    path: "/blog/cimke/:tagSeoName",
    component: _a50d881c,
    name: "blogListPageByTag___hu-HU"
  }, {
    path: "/blog/gyujtemeny/:collectionSeoName",
    component: _33530cd6,
    name: "blogListPageByCollection___hu-HU"
  }, {
    path: "/blog/szakma/:professionSeoName",
    component: _25c6579a,
    name: "blogListPageByProfession___hu-HU"
  }, {
    path: "/blog/tevekenyseg/:professionTaskSeoName",
    component: _4ca8bc10,
    name: "blogListPageByProfessionTask___hu-HU"
  }, {
    path: "/demo/arajanlat/:publicId",
    component: _914b5e6c,
    name: "demoPublicPriceOfferPage___hu-HU"
  }, {
    path: "/demo/arajanlatok/:id",
    component: _defd20c4,
    name: "demoPriceOffersEditPage___hu-HU"
  }, {
    path: "/fiokom/arajanlatok/:id",
    component: _1805dc15,
    name: "priceOffersEditPage___hu-HU"
  }, {
    path: "/fiokom/beallitasaim/:highlightedSetting?",
    component: _0b387cfc,
    name: "settingsPage___hu-HU"
  }, {
    path: "/fiokom/elofizetes/:serviceTypeSeoName",
    component: _55c78716,
    name: "subscriptionServiceTypePage___hu-HU"
  }, {
    path: "/fiokom/munkam/:personTenderId",
    component: _533c1a7c,
    name: "myJobPage___hu-HU"
  }, {
    path: "/fiokom/terv/:planPublicId",
    component: _2e43f44e,
    name: "planViewerPage___hu-HU"
  }, {
    path: "/fiokom/tervezok/:designerId",
    component: _771b8445,
    name: "designerPage___hu-HU"
  }, {
    path: "/inspiracio/szakma/:professionSeoName",
    component: _1ffae464,
    name: "inspirationProfessionPage___hu-HU"
  }, {
    path: "/inspiracio/tevekenyseg/:professionTaskSeoName",
    component: _67413166,
    name: "inspirationProfessionTaskPage___hu-HU"
  }, {
    path: "/landing/ajanlatkeres/:professionSeoName",
    component: _b1478e8a,
    name: "landing-request-tender-professionSeoName___hu-HU"
  }, {
    path: "/szakifizu/atlag/:professionSeoName",
    component: _65f06c70,
    name: "salaryCheckerAveragePage___hu-HU"
  }, {
    path: "/szakivalaszol/szakma/:profession",
    component: _3979a7c4,
    name: "professionQuestions___hu-HU"
  }, {
    path: "/szakivalaszol/tevekenyseg/:professionTask",
    component: _3979a7c4,
    name: "professionTaskQuestions___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkeresek/:id",
    component: _2632dc8e,
    name: "conductorTendersEditPage___hu-HU"
  }, {
    path: "/vezerlo/ajanlatkero-modulok/:id",
    component: _7db80593,
    name: "conductorRequestTenderPageModulesEditPage___hu-HU"
  }, {
    path: "/vezerlo/beallitasok/:id",
    component: _4bb4ea60,
    name: "conductorSettingsEditPage___hu-HU"
  }, {
    path: "/vezerlo/email-sablonok/:id",
    component: _01104412,
    name: "conductorEmailTemplatesEditPage___hu-HU"
  }, {
    path: "/vezerlo/ertekelesek/:id",
    component: _3c0592a5,
    name: "conductorRatingsEditPage___hu-HU"
  }, {
    path: "/vezerlo/ertesitesek/:id",
    component: _46251a52,
    name: "conductorNotificationsEditPage___hu-HU"
  }, {
    path: "/vezerlo/felhasznalok/:id",
    component: _4f6001ed,
    name: "conductorPersonsEditPage___hu-HU"
  }, {
    path: "/vezerlo/gyik/:id",
    component: _adc2c74c,
    name: "conductorFaqsEditPage___hu-HU"
  }, {
    path: "/vezerlo/hivasnaplo-tipusok/:id",
    component: _0c562942,
    name: "conductorPersonEventLogTypesEditPage___hu-HU"
  }, {
    path: "/vezerlo/inspiraciok/:id",
    component: _213b99f4,
    name: "conductorInspirationsEditPage___hu-HU"
  }, {
    path: "/vezerlo/jarasok/:id",
    component: _b99b6c52,
    name: "conductorSubcountiesEditPage___hu-HU"
  }, {
    path: "/vezerlo/jogi-dokumentumok/:id",
    component: _85e6995a,
    name: "conductorLegalDocumentsViewPage___hu-HU"
  }, {
    path: "/vezerlo/kerdesek/:id",
    component: _240e26fc,
    name: "conductorQuestionEditPage___hu-HU"
  }, {
    path: "/vezerlo/megjelolt-kapcsolatok/:id",
    component: _55f67663,
    name: "conductorFlaggedContactsEditPage___hu-HU"
  }, {
    path: "/vezerlo/minipiacok/:id",
    component: _8e93fb04,
    name: "conductorMiniMarketsEditPage___hu-HU"
  }, {
    path: "/vezerlo/szakma-zonak/:id",
    component: _9e435214,
    name: "conductorZonesEditPage___hu-HU"
  }, {
    path: "/vezerlo/szakmacsoportok/:id",
    component: _3badca74,
    name: "conductorProfessionGroupsEditPage___hu-HU"
  }, {
    path: "/vezerlo/szakmak/:id",
    component: _dcbec634,
    name: "conductorProfessionsEditPage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatasok/:id",
    component: _4554894a,
    name: "conductorServicesEditPage___hu-HU"
  }, {
    path: "/vezerlo/szolgaltatastipusok/:id",
    component: _1c252d90,
    name: "conductorServiceTypesEditPage___hu-HU"
  }, {
    path: "/vezerlo/tevekenyseg-oldalak/:id",
    component: _52e18f1c,
    name: "conductorProfessionTaskPagesEditPage___hu-HU"
  }, {
    path: "/vezerlo/zona-csapatok/:id",
    component: _906fb26c,
    name: "conductorMiniMarketTeamsEditPage___hu-HU"
  }, {
    path: "/szakifizu/atlag/:professionSeoName/munkak",
    component: _3f691353,
    name: "salaryCheckerJobsPage___hu-HU"
  }, {
    path: "/ajanlatkeres-lezarasa/:personTenderId",
    component: _77a53804,
    name: "close-tender-personTenderId___hu-HU"
  }, {
    path: "/ajanlatkeres/:activeTab",
    component: _3e34b71c,
    name: "requestForTenderTab___hu-HU"
  }, {
    path: "/arajanlat/:publicId",
    component: _d47cdb10,
    name: "publicPriceOfferPage___hu-HU"
  }, {
    path: "/arak/:professionTask",
    component: _8b1fad3c,
    name: "prices___hu-HU"
  }, {
    path: "/arcsekkolo/:professionSeoName",
    component: _1a9412cc,
    name: "arcsekkolo-professionSeoName___hu-HU"
  }, {
    path: "/blog/:articleSeoName",
    component: _759b63ea,
    name: "blogArticlePage___hu-HU"
  }, {
    path: "/dokumentumok/:type",
    component: _89129daa,
    name: "documentsTypePage___hu-HU"
  }, {
    path: "/inspiracio/:inspirationSeoName",
    component: _62fd8224,
    name: "inspirationPage___hu-HU"
  }, {
    path: "/landing/:slug?",
    component: _225498fb,
    name: "landing-slug___hu-HU"
  }, {
    path: "/megyek/:county",
    component: _00df2ea8,
    name: "county___hu-HU"
  }, {
    path: "/partner-ajanlatkeres/:partnerCode?",
    component: _5981deac,
    name: "partner-ajanlatkeres-partnerCode___hu-HU"
  }, {
    path: "/projects/:id?",
    component: _58c66acc,
    name: "projects-id___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName",
    component: _40a8adb6,
    name: "professionalPage___hu-HU"
  }, {
    path: "/szakemberek/:profession",
    component: _8f771e38,
    name: "professionPage___hu-HU"
  }, {
    path: "/szakivalaszol/:questionSeoName",
    component: _1536bb6f,
    name: "questionPage___hu-HU"
  }, {
    path: "/szakma/:professionGroup",
    component: _ee6be1fa,
    name: "professionsPage___hu-HU"
  }, {
    path: "/tender/:tenderId",
    component: _c819e8c6,
    name: "tender-tenderId___hu-HU"
  }, {
    path: "/terv/:planPublicId",
    component: _3ff97b60,
    name: "publicPlanPage___hu-HU"
  }, {
    path: "/valassz/:decisionTestSeoName?",
    component: _a1b16392,
    name: "valassz-decisionTestSeoName___hu-HU"
  }, {
    path: "/munka/:tenderId/pontositsunk",
    component: _502ba96f,
    name: "tender-tenderId-specify___hu-HU"
  }, {
    path: "/professionals/:profession?/events",
    component: _2b383690,
    name: "professionals-profession-events___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName/ertekeles",
    component: _d01b40a8,
    name: "professionalRatingPage___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName/admin/balance",
    component: _23a89800,
    name: "adminBalance___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName/admin/merge",
    component: _08378e5c,
    name: "adminMerge___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName/admin/person-event-log",
    component: _006ec025,
    name: "personEventLog___hu-HU"
  }, {
    path: "/szakember/:professionalSeoName/admin/transfers",
    component: _269d9be8,
    name: "adminTransfers___hu-HU"
  }, {
    path: "/munka/:tenderId/pontositsunk/:activeTab",
    component: _c108683a,
    name: "specifyTenderPage___hu-HU"
  }, {
    path: "/szakemberek/:profession/szakivalaszol/:questionSeoName",
    component: _15c88c18,
    name: "professionals-profession-szakivalaszol-questionSeoName___hu-HU"
  }, {
    path: "/arcsekkolo/:professionSeoName?/:priceTagSeoName",
    component: _3ebeabe0,
    name: "arcsekkolo-professionSeoName-priceTagSeoName___hu-HU"
  }, {
    path: "/arkalkulator/:professionTask/:step?",
    component: _e9c1468c,
    name: "priceCalculatorPage___hu-HU"
  }, {
    path: "/inspiracio/:inspirationSeoName/:pictureSeoName",
    component: _4b7e0f5e,
    name: "inspirationPicturePage___hu-HU"
  }, {
    path: "/szakemberek/:profession/:city",
    component: _4c672042,
    name: "professionals___hu-HU"
  }, {
    path: "/megyek/:county/:city/:subCity?",
    component: _a8282a72,
    name: "countyCity___hu-HU"
  }, {
    path: "/szakemberek/:profession/:parentCity/:city",
    component: _cb850e72,
    name: "professionalsParentCity___hu-HU"
  }, {
    path: "/*",
    component: _03cf66c8,
    name: "all___hu-HU"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
